import Vue from 'vue';
import Router from 'vue-router';
import store from '@/assets/js/store';
const Schedules = () => import('@/components/Schedules');
const Arrangements = () => import('@/components/Arrangements');
const VideoArrangements = () => import('@/components/VideoArrangements');
const Entries = () => import('@/components/Entries');
const Entry = () => import('@/components/Entry');
const Login = () => import('@/components/Login');
const EntryGroup = () => import('@/components/EntryGroup'); //集体评分
const InterViewer = () => import('@/components/interviewer/Base');
const InterViewerInterview = () => import('@/components/interviewer/Interview');
const InterViewerMessage = () => import('@/components/interviewer/Message');
const InterViewerLogin = () => import('@/components/interviewer/Login');
const InterDetection = () => import('@/components/interviewer/Detection');
const Detection = () => import('@/components/Detection');
const PDF = () => import('@/components/PDF');
// 承诺书页面
const Commitment = () => import('@/views/commitment/index');
// 拍照签到
const Interviewer = () => import('@/views/interviewer/index');

const ScoreChart = () => import('@/components/ScoreChart');
// 移动端预览列表
const viewTable = () => import('@/views/resultTable/index.vue');
// 签到页面
const stuViewer = () => import('@/views/stuViewer/index.vue');

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: { name: 'Login' },
    },
    {
      path: '/schedules',
      name: 'Schedules',
      component: Schedules,
      meta: { requiresAuth: true },
    },
    {
      path: '/commitment',
      name: 'Commitment',
      component: Commitment,
      meta: { requiresAuth: true },
    },
    {
      path: '/interviewer',
      name: 'Interviewer',
      component: Interviewer,
      meta: { requiresAuth: true },
    },
    {
      path: '/arrangements',
      name: 'Arrangements',
      component: Arrangements,
      meta: { requiresAuth: true },
    },
    {
      path: '/scoreChart',
      name: 'ScoreChart',
      component: ScoreChart,
      meta: { requiresAuth: true },
    },
    {
      path: '/videoarrangements',
      name: 'VideoArrangements',
      component: VideoArrangements,
      meta: { requiresAuth: true },
    },
    {
      path: '/entries',
      name: 'Entries',
      component: Entries,
      meta: { requiresAuth: true },
    },
    {
      path: '/entry',
      name: 'Entry',
      component: Entry,
      meta: { requiresAuth: true },
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/entryGroup',
      name: 'EntryGroup',
      component: EntryGroup,
      meta: { requiresAuth: true },
    },
    {
      path: '/interViewer',
      name: 'InterViewer',
      component: InterViewer,
      children: [
        {
          path: 'message/:scheduleid/:arrangementid/:entryid',
          name: 'InterViewerMessage',
          component: InterViewerMessage,
        },
        {
          path: 'login/:scheduleid/:arrangementid/:entryid',
          name: 'InterViewerLogin',
          component: InterViewerLogin,
        },
      ],
    },
    {
      path: '/interViewer/interview/:scheduleid/:arrangementid/:entryid',
      name: 'InterViewerInterview',
      component: InterViewerInterview,
    },
    {
      path: '/interViewer/detection',
      name: 'InterDetection',
      component: InterDetection,
    },
    {
      path: '/detection',
      name: 'Detection',
      component: Detection,
    },
    {
      path: '/pdf',
      name: 'PDF',
      component: PDF,
    },
    {
      path: '/viewTable',
      name: 'viewTable',
      component: viewTable,
    },
    {
      path: '/stuViewer',
      name: 'stuViewer',
      component: stuViewer,
    },
    {
      path: '/video/conference',
      name: 'videoConference',
      component: () => import('@/components/videoInterview/VideoConference.vue'),
    },
  ],
});

router.afterEach((to, from) => {
  // 如果未登录，则直接跳转到login页面
  if (to.path.toLowerCase().indexOf('/interviewer') === 0) {
    // 如果是候选人的面试页，则跳过登录验证
    return;
  }
  if (to.path.toLowerCase().indexOf('/detection') === 0) {
    // 如果是视频面试设备检测页，则跳过登录验证
    return;
  }
  if (!store.state.isLogin && to.path !== '/login') {
    // 在登录页时未登录不要重复跳转
    router.push({ name: 'Login' });
  }
  if (store.state.isLogin && to.name === 'Login') {
    // 如果登录状态，则直接跳转到schedule页面,以防同时登录两个账号
    router.push({ name: 'Schedules' });
  }
});

// vue-router 的全局前置守卫和全局后置钩子都可以实现根据登入状态的跳转
// 以下就是一个全局前置守卫的实现，这里注释掉，现在用全局后置钩子来跳转

// router.beforeEach((to, from, next) => {
//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     // this route requires auth, check if logged in
//     // if not, redirect to login page.
//     if (!store.state.isLogin) {
//       next({
//         name: 'Login'
//       })
//     } else {
//       next()
//     }
//   } else {
//     if (store.state.isLogin && to.name === "Login") {
//       next({
//         name: 'Schedules'
//       })
//     } else {
//       next()
//     }
//   }
// })

export default router;
